import React, { useEffect, useState } from "react";
import Style from "./DeliveryFinishedRequest.module.css";
import { Divider } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfo,
  faMapPin,
  faMoneyBillWave,
} from "@fortawesome/fontawesome-free-solid";
import moment from "moment-jalaali";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { errorToast } from "../../../../Toast/Toast";
import { getDeliveryRequestDataApi } from "../../../../Api/DeliveryServices";
import { separate } from "../../../../Seprate/Seprate";

const DeliveryFinishedRequest = () => {
  const [TravelsState, setTravelsState] = useState();
  useEffect(() => {
    getTravelDataHandler();
  }, []);
  const getTravelDataHandler = () => {
    getDeliveryRequestDataApi((succ, res) => {
      if (succ) {
        if (res.staus === -1) {
          errorToast(res.message);
        } else {
          setTravelsState(res.deliveries);
        }
      } else {
        console.log(res);
      }
    });
  };
  return (
    <div className={Style.ComponentHolder}>
      {TravelsState === undefined ? (
        <p style={{direction:"rtl"}}>درحال دریافت اطلاعات....</p>
      ) : TravelsState.length === 0 ? (
        <p style={{direction:"rtl"}}>درخواستی یافت نشد!</p>
      ) : (
        <ul className={Style.ListHolder}>
          {TravelsState.map((item) => {
            return (
              <li key={item.id} className={Style.TravelHolder}>
                <div className={Style.DateHolder}>
                  <FontAwesomeIcon icon={faCalendar} color="#d00d8f" />
                  <p>
                    {moment
                      .unix(parseInt(item.end_date??item.request_date))
                      .format("jYYYY/jM/jD--HH:mm")}
                  </p>
                </div>
                <section className={Style.PartHolder}>
                  <Divider>مشخصات</Divider>
                  <div className={Style.userLocationInfo}>
                    <p>
                      <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                      مبدا:{item?.routs[0]?.description}
                    </p>
                    <div>
                      <strong>نام و نام خانوادگی: </strong>
                      <span>{item?.routs[0].name}</span>
                    </div>
                    <div>
                      <strong>شماره تماس: </strong>
                      <span style={{ color: "#d00d8f" }}>
                        {item?.routs[0].phone}
                      </span>
                    </div>
                    {item?.routs[0]?.routes_description && (
                      <div>
                        <strong>توضیحات: </strong>
                        <span>{item?.routs[0]?.routes_description}</span>
                      </div>
                    )}
                  </div>
                  <div className={Style.userLocationInfo}>
                    <p>
                      <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                      مقصد:{item?.routs[1]?.description}
                    </p>
                    <div>
                      <strong>گیرنده: </strong>
                      <span>{item?.routs[1].name}</span>
                    </div>
                    <div>
                      <strong>شماره تماس: </strong>
                      <span style={{ color: "#d00d8f" }}>
                        {item?.routs[1].phone}
                      </span>
                    </div>
                    {item?.routs[1]?.routes_description && (
                      <div>
                        <strong>توضیحات: </strong>
                        <span>{item?.routs[1]?.routes_description}</span>
                      </div>
                    )}
                  </div>

                  {item?.routs[2] && (
                    <div className={Style.userLocationInfo}>
                      <p>
                        <FontAwesomeIcon icon={faMapPin} color="#d00d8f" />
                        مقصد دوم:{item?.routs[2]?.description}
                      </p>
                      <div>
                        <strong>گیرنده دوم: </strong>
                        <span>{item?.routs[2].name}</span>
                      </div>
                      <div>
                        <strong>شماره تماس: </strong>
                        <span style={{ color: "#d00d8f" }}>
                          {item?.routs[2].phone}
                        </span>
                      </div>
                      {item?.routs[2]?.routes_description && (
                        <div>
                          <strong>توضیحات: </strong>
                          <span>{item?.routs[2]?.routes_description}</span>
                        </div>
                      )}
                    </div>
                  )}
                </section>

                {item?.driver.length!==0&&<section className={Style.PartHolder}>
                  <Divider>اطلاعات پیک</Divider>
                  <div className={Style.DriverInfoHolder}>
                    <div className={Style.ProfileHolder}>
                      <img
                        src={`https://cdn.barest.ir/deliver/photo/${item.photo}.jpg`}
                        alt=""
                      />
                    </div>
                    <div className={Style.DriverInfoPartOne}>
                      <h6>{item.name}</h6>
                      <p>
                        {item.vehicle_model} {item.vehicle_color}
                      </p>
                    </div>
                    <div className={Style.DriverInfoParttwo}>
                      <p className={Style.CarPlateHolder}>
                        {item.vehicle_plate}
                      </p>
                    </div>
                  </div>
                </section>}

                <section className={Style.PartHolder}>
                  <Divider>هزینه</Divider>
                  <div className={Style.PricePartHolder}>
                    <p>
                      <FontAwesomeIcon icon={faMoneyBillWave} color="#d00d8f" />
                       
                      <span style={{ color: "green" }}>
                      مبلغ:{separate(item?.delivery)} تومان
                      </span>
                    </p>
                  </div>
                </section>
                <section className={Style.PartHolder}>
                  <Divider>وضعیت درخواست</Divider>
                  <div className={Style.PricePartHolder}>
                    <p className={Style.RequestStatusHolder}>
                      <FontAwesomeIcon icon={faInfo} color="#d00d8f" /> 
                      {item.status === "4"
                        ? "مرسوله تحویل داده شد"
                        : item.status === "-2"
                        ? "درخواست لغو شده"
                        : item.status === "-1"
                        ? "توسط پیک کنسل شد!"
                        : null}
                    </p>
                  </div>
                </section>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default DeliveryFinishedRequest;
